export default __webpack_public_path__ + "static/media/logo-registro_color.07bb6885.png";